<script lang="ts">
  import ImpersonationBar from "@shared/svelte/Components/Layout/Header/ImpersonationBar.svelte";
  import LiquorLicenseInfoBar from "@retailer/svelte/ProductLines/LiquorLicenseInfoBar.svelte";
  import NewCartButton from "@shared/svelte/Components/Layout/Header/NewCartButton.svelte";
  import NewLocationChooser from "@shared/svelte/Components/Layout/Header/NewLocationChooser.svelte";
  import Notifications from "@shared/svelte/Components/Layout/Header/Notifications/Notifications.svelte";
  import Search from "@shared/svelte/Components/Layout/Header/Search.svelte";
  import SideMenu from "@shared/svelte/Components/Layout/Header/SideMenu/SideMenu.svelte";
  import { Header, Logo } from "@getprovi/craft";
  import { isOnProductTypeHeaderPage } from "@retailer/services/liquor_license_service";
  import { page } from "@roxi/routify";
  import { EventTracking } from "@shared/services/event_tracking/events";

  $: showLiquorLicenseInfoBar = !isOnProductTypeHeaderPage($page) as boolean;
</script>

<ImpersonationBar />

<Header>
  <SideMenu />
  <Logo href="/" class="area-logo w-48 tablet:w-56" id="logo" />

  <Search />
  <NewLocationChooser />
  <Notifications />
  <NewCartButton />
</Header>

<LiquorLicenseInfoBar {showLiquorLicenseInfoBar} />
